import { render } from "./Statuses-tab.vue?vue&type=template&id=3a00e1ce&scoped=true"
import script from "./Statuses-tab.vue?vue&type=script&lang=js"
export * from "./Statuses-tab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=3a00e1ce&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a00e1ce"]])

export default __exports__